import { createTheme } from '@mui/material/styles';
import GetCookie from '../Services/GetCookie';
import Data from '../Data/.json';

export type ThemeMode = 'light' | 'dark';

export function resolveMode(): ThemeMode {
    const cookie = GetCookie(Data.mode);
    if (cookie === 'light' || cookie === 'dark') return cookie;
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export const fontFamily = "'Inter Variable', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif";

export function buildTheme(mode: ThemeMode) {
    const dark = mode === 'dark';
    return createTheme({
        palette: {
            mode,
            primary: { main: dark ? '#FFFFFF' : '#191C60', contrastText: dark ? '#0B0D2E' : '#FFFFFF' },
            secondary: { main: dark ? '#8EA2FF' : '#4F6BED' },
            background: { default: dark ? '#07091A' : '#FFFFFF', paper: dark ? '#0F1328' : '#FFFFFF' },
            text: { primary: dark ? '#F4F5F8' : '#0B1324', secondary: dark ? '#A9B0C0' : '#4B5565' },
            divider: dark ? 'rgba(255,255,255,0.08)' : '#E4E7EC',
        },
        shape: { borderRadius: 10 },
        typography: {
            fontFamily,
            h1: { fontWeight: 600, letterSpacing: '-0.035em', lineHeight: 1.05 },
            h2: { fontWeight: 600, letterSpacing: '-0.03em', lineHeight: 1.1 },
            h3: { fontWeight: 600, letterSpacing: '-0.025em', lineHeight: 1.15 },
            h4: { fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.2 },
            h5: { fontWeight: 600, letterSpacing: '-0.015em', lineHeight: 1.3 },
            h6: { fontWeight: 600, letterSpacing: '-0.01em' },
            body1: { lineHeight: 1.7 },
            button: { textTransform: 'none', fontWeight: 500, letterSpacing: 0 },
        },
        components: {
            MuiButton: { defaultProps: { disableElevation: true } },
            MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: { borderRadius: 10 },
                },
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: { fontSize: 12, fontWeight: 500, borderRadius: 6, backgroundColor: '#0B1324' },
                },
            },
        },
    });
}
